import { theme } from '@zappyrent/hundop';
import { upperFirst } from 'lodash';
import { useTranslation } from 'react-i18next';
import Media from 'react-media';

import useStore from '../../../../../store';
import { LandlordBooking, Status } from '../../../../../types/bookings';
import {
  StyledButton,
  StyledButtonWrapper,
  StyledGrid,
} from '../BookingInformationButton.styles';

interface IBookingInformationProps {
  booking: LandlordBooking;
  onAcceptOpen: () => void;
  onRejectOpen: () => void;
  onCounterOfferOpen: () => void;
}

const BookingInformationLandlordButton = ({
  booking,
  onAcceptOpen,
  onRejectOpen,
  onCounterOfferOpen,
}: IBookingInformationProps) => {
  const { t } = useTranslation(['common']);
  const { user } = useStore(state => ({
    user: state.user,
  }));
  return (
    <>
      {Status.PENDING === booking.status &&
        booking?.pricing.counter_offer === 0 && (
          <Media
            queries={{
              mobile: `(max-width: calc(${theme.breakpoints.m}))`,
              desktop: `(min-width: ${theme.breakpoints.m})`,
            }}
          >
            {matches => (
              <>
                {matches.desktop && (
                  <StyledButtonWrapper flexProperty="space-between">
                    <StyledButton
                      variant="secondary"
                      onClick={onCounterOfferOpen}
                    >
                      {upperFirst(t('common:counterOffer'))}
                    </StyledButton>
                    <StyledButtonWrapper flexProperty="space-between">
                      <StyledButton
                        user={user?.type}
                        variant="secondary"
                        onClick={onRejectOpen}
                      >
                        {upperFirst(t('common:reject'))}
                      </StyledButton>
                      <StyledButton user={user?.type} onClick={onAcceptOpen}>
                        {upperFirst(t('common:accept'))}
                      </StyledButton>
                    </StyledButtonWrapper>
                  </StyledButtonWrapper>
                )}
                {matches.mobile && (
                  <StyledGrid>
                    <StyledButton user={user?.type} onClick={onAcceptOpen}>
                      {upperFirst(t('common:accept'))}
                    </StyledButton>
                    <StyledButton
                      user={user?.type}
                      variant="secondary"
                      onClick={onRejectOpen}
                    >
                      {upperFirst(t('common:reject'))}
                    </StyledButton>
                    <StyledButton
                      variant="secondary"
                      onClick={onCounterOfferOpen}
                    >
                      {upperFirst(t('common:counterOffer'))}
                    </StyledButton>
                  </StyledGrid>
                )}
              </>
            )}
          </Media>
        )}
    </>
  );
};

export default BookingInformationLandlordButton;
